<template>
  <div class="hd-cell" :class="{ isMobile: isMobile }">
    <div v-if="item.type == 0" class="kefu">
      <div class="kefu-img"></div>
      <el-button @click="chatShow" type="primary" size="mini"
        >咨询顾问</el-button
      >
    </div>
    <div
      v-else
      :class="{
        normal: item.type !== activeRowIndex + 1,
        active: item.type == activeRowIndex,
        'active-by':
          item.type == activeRowIndex && item.title == '白银会员' && isMobile,
        'single-top': item.type % 2 !== 0,
        'double-top': item.type % 2 == 0,
      }"
    >
      <div class="normal-box" v-show="item.type !== activeRowIndex">
        <div class="normal-title">
          <i class="iconfont iconhuiyuan" :style="{ color: item.color }"></i
          >{{ item.title }}
        </div>
        <div class="normal-desc">适用于{{ item.desc }}</div>
        <el-button
          type="primary"
          @click="getPrice(item.mode)"
          size="mini"
          :style="{ 'background-color': item.type == 5 ? '#a6a6a6' : '' }"
          >获取报价</el-button
        >
      </div>
      <div
        class="hover-box"
        :class="{ 'price-box': showPrice }"
        v-show="item.type == activeRowIndex"
      >
        <div
          :class="{ 'hover-top': true }"
          :style="{ background: item.hoverColor }"
        >
          <div class="hover-title">
            <i class="iconfont iconhuiyuan"></i>{{ item.title }}
          </div>
        </div>
        <div class="showPrice" v-if="showPrice">
          <span v-html="item.price == 0 ? '' : '￥ ' + item.price"></span>
        </div>
        <div v-if="item.hoverDesc" class="hoverDesc">
          <div v-html="item.hoverDesc"></div>
        </div>
        <div class="hover-desc" :class="{ showP: showPrice }">
          适用于{{ item.desc }}
        </div>
        <el-button
          type="primary"
          v-if="!showPrice"
          size="mini"
          @click="getPrice(item)"
          :style="{ background: item.hoverColor, margin: '10px 0px 0px' }"
        >
          <span v-if="item.title == '钻石会员'">咨询顾问</span>
          <span v-else>获取报价</span>
        </el-button>
        <el-button
          type="primary"
          v-if="showPrice"
          size="mini"
          @click="payHandler(item)"
          :style="{ background: item.hoverColor, margin: '6px 0 0' }"
          >{{ item.price == 0 ? '马上体验' : '马上购买' }}</el-button
        >
      </div>
    </div>
    <remittance
      :item="item"
      @onCancel="onCancel"
      :dialogVisible="dialogVisible"
    ></remittance>
  </div>
</template>
<script>
import { LOGIN_API,REPORT_API } from "@/api.js";
import remittance from '@/components/pay/remittance'
export default {
  name: 'hd-cell',
  props: ['item', 'index', 'activeRowIndex'],
  components: {
    remittance,
  },
  data() {
    return {
      showPrice: false,
      dialogVisible: false,
      isMobile: false,
    }
  },
  mounted() {
    this.isMobile = this.$store.state.app.device
  },
  methods: {
    onCancel() {
      this.dialogVisible = false
    },
    // 在线咨询顾问
    chatShow() {
      this.$bus.emit('chatShow')
    },
    // xx
    openHandler() {
      let post = {
        type: 104,
      }
      this.info = this.$cookies.get('hr_token')
      if (this.info) {
        this.$axios.defaults.headers.common['authorization'] = this.info.token
      }
      this.$axios
        .post(`${REPORT_API}/api/enterprise/buy`, post)
        .then((res) => {
          if (res.data.code == 0) {
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    // 获取报价
    getPrice(item) {
      //如果登录，跳转到控制台
      this.info = this.$cookies.get('hr_token')
      if (this.info) {
        if (this.info.finish) {
          this.viewHandler(item)
        } else {
          this.$message.warning('请先完善企业信息！')
          this.$router.push('/register/compInfo?backURL=' + this.$route.path)
        }
      }
      //如果没有登录，直接跳转到登录
      else {
        this.$router.push('/login?backURL=' + this.$route.path)
      }
    },
    viewHandler(item) {
      if (item.mode == 104) {
        this.openHandler()
        this.$bus.emit('chatShow')
      } else {
        this.showPrice = true
      }
    },
    payHandler(item) {
      if (item.price == 0) {
        window.open('https://kao.acmcoder.com/b/')
      } else if (item.mode == 104) {
        this.$bus.emit('chatShow')
      } else {
        if (item.price == 0) {
          this.$message.error('此会员无需购买！')
          return
        }
        this.dialogVisible = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.stop-hd {
  .hd-cell {
    .hover-box {
      margin-top: 0px;
      height: 170px;
    }
  }
}
.showPrice {
  padding: 15px 0px 5px;
  color: #666;
  span {
    font-size: 24px;
    font-weight: bold;
    color: #f5a352;
  }
}
.hd-cell {
  flex: 1;
  text-align: center;
  background-color: #fff;
  .white {
    width: 100%;
    height: 30px;
  }
  .el-button {
    background-color: #29bdb9;
    border: 0;
    border-radius: 2px;
    margin-top: 10px;
    &:hover {
      background-color: rgba($color: #29bdb9, $alpha: 0.6);
    }
  }
  .kefu {
    box-shadow: 0px 10px 15px 0px #edf5f5;
    padding: 0 20px;
    width: 200px;
    height: 170px;
    border-top: 2px solid #96e0de;

    .kefu-img {
      margin: auto;
      background-image: url('/static/images/price/kefu.png');
      width: 74px;
      height: 86px;
      background-size: cover;
      margin: 20px auto 0px;
    }
  }
  .normal {
    box-shadow: -8px 4px 15px #edf5f5;
  }
  .normal-box {
    font-size: 14px;
    padding: 20px;
    height: 170px;

    .normal-desc {
      color: #666;
      font-size: 10px;
      padding: 20px 0;
    }
  }
  .iconhuiyuan {
    padding-right: 4px;
    padding-top: 4px;
  }
  .active {
    box-shadow: 0px -8px 12px 2px rgba(0, 0, 0, 0.2) !important;
  }
  .active-by {
    .hover-desc {
      padding: 0 !important;
    }
  }
  .hover-box {
    z-index: 100;
    padding: 0;
    color: #fff;
    height: 202px;
    margin-top: -32px;
    .hover-top {
      padding: 5px 0;
      .hover-title {
        font-size: 16px;
        padding: 6px 0px;
      }
    }
    .hover-desc {
      font-size: 10px;
      color: #666;
      padding: 20px 0px 10px;
    }
    .hoverDesc {
      color: #666;
      font-size: 12px;
      text-align: center;
      padding: 10px 10px 0px 10px;
      margin: 6px 0px -5px;
    }

    &.price-box {
      .showPrice {
        padding: 10px 0px 5px;
      }

      .hoverDesc {
        padding: 6px 0px 6px;
        margin: 0px;
      }

      .hover-desc {
        padding: 6px 0px;
      }
    }
  }
  .single-top {
    border-top: 2px solid #29bdb9;
  }
  .double-top {
    border-top: 2px solid #96e0de;
  }
}
.isMobile {
  .hover-desc {
    margin: 15px 0px;
  }
  .showP.hover-desc {
    margin: 5px 0px;
  }
}

@media screen and (max-width: 600px) {
  .hd-cell {
    .kefu {
      width: initial;
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .hd-cell {
    .kefu {
      width: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tariff/hd-cell/index.vue